"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Drawer = _interopRequireDefault(require("@mui/material/Drawer"));
var Drawer = /*#__PURE__*/_react.default.forwardRef(function (props, paperProps) {
  var show = props.show,
    onClose = props.onClose,
    children = props.children,
    className = props.className;
  return /*#__PURE__*/_react.default.createElement(_Drawer.default, {
    className: className,
    anchor: "right",
    open: show,
    onClose: onClose,
    PaperProps: {
      ref: paperProps
    }
  }, children);
});
Drawer.propTypes = {
  onClose: _propTypes.default.func.isRequired,
  children: _propTypes.default.element.isRequired,
  show: _propTypes.default.bool,
  className: _propTypes.default.string
};
Drawer.defaultProps = {
  className: '',
  show: false
};
var _default = Drawer;
exports.default = _default;